
import React from 'react';
import { Button } from '@/components/ui/button';
import { useQuickscan } from '@/contexts/QuickscanContext';
import { Zap, Leaf, TrendingUp } from 'lucide-react';
import { Logo } from '../Logo';

export const WelcomeScreen = () => {
  const { nextStep } = useQuickscan();

  return (
    <div className="text-center max-w-2xl mx-auto">
      <div className="relative mb-6">
        <div className="absolute inset-0 animate-energy-pulse">
          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-energy-green to-energy-blue rounded-full flex items-center justify-center">
            <Zap className="w-12 h-12 text-white" />
          </div>
        </div>
        <div className="w-24 h-24 mx-auto bg-gradient-to-br from-energy-green to-energy-blue rounded-full flex items-center justify-center">
          <Zap className="w-12 h-12 text-white" />
        </div>
      </div>
      
      {/* Greenvision Logo */}
      <div className="mb-6">
        <Logo className="h-16 md:h-20 mx-auto object-contain" />
      </div>
      
      <h1 className="text-4xl font-bold text-energy-green mb-4">
        Energy Quickscan
      </h1>
      
      <p className="text-xl text-gray-600 mb-8">
        Ontdek in 3 minuten jouw energiebesparingspotentieel en de mogelijkheden voor energieopslag en netonafhankelijkheid.
      </p>
      
      <div className="grid md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <TrendingUp className="w-8 h-8 text-energy-blue mx-auto mb-3" />
          <h3 className="font-semibold text-gray-800 mb-2">Besparingspotentieel</h3>
          <p className="text-sm text-gray-600">Krijg inzicht in mogelijke kostenbesparingen</p>
        </div>
        
        <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <Leaf className="w-8 h-8 text-energy-green mx-auto mb-3" />
          <h3 className="font-semibold text-gray-800 mb-2">CO2 Reductie</h3>
          <p className="text-sm text-gray-600">Zie je impact op het milieu</p>
        </div>
        
        <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <Zap className="w-8 h-8 text-energy-orange mx-auto mb-3" />
          <h3 className="font-semibold text-gray-800 mb-2">Slimme Oplossingen</h3>
          <p className="text-sm text-gray-600">Ontdek de beste energieoplossingen</p>
        </div>
      </div>
      
      <Button 
        onClick={nextStep}
        size="lg"
        style={{ backgroundColor: '#014336' }}
        className="hover:opacity-90 text-white px-8 py-3 text-lg animate-glow transition-opacity"
      >
        Start Quickscan
      </Button>
    </div>
  );
};
